import { cva } from "class-variance-authority";

interface RadioProps {
  color?: "acceptable" | "warning" | "danger";
  size?: "sm" | "md" | "lg";
  name?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  value?: string | number;
  checked?: boolean;
}

const radioStyles = cva("radio ", {
  variants: {
    size: {
      sm: "radio-sm",
      md: "",
      lg: "radio-lg",
    },
    color: {
      default: "",
      acceptable: "!bg-[#296573] !border-[#296573",
      warning: "!bg-[#FFA500] !border-[#FFA500]",
      danger: "!bg-[#8D4F61] !border-[#8D4F61]",
    },
  },
  defaultVariants: {
    size: "lg",
    color: "acceptable",
  },
});

export function Radio({
  onChange,
  onClick,
  color,
  size,
  name,
  checked,
  value,
}: RadioProps) {
  return (
    <input
      className={radioStyles({ size, color: checked ? color : "default" })}
      onChange={onChange}
      name={name}
      type="radio"
      value={value}
      checked={checked}
      onClick={onClick}
      readOnly
    />
  );
}
